import { useEffect } from 'react';
import RealEstatesForm from '../RealEstatesForm';

export default function RealEstatesCreateModal({
  handleCreate,
  toggleModal,
  realEstateTypes,
}) {
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  return (
    <div
      id="default-modal"
      tabIndex="-1"
      aria-hidden="true"
      className="fixed inset-0 z-50 flex justify-center items-center w-full h-full bg-gray-900 bg-opacity-50"
      onClick={toggleModal}
    >
      <div className="relative p-4 w-full max-w-5xl max-h-full">
        {/* Modal content */}
        <div
          className="relative bg-white rounded-lg shadow max-h-[calc(100vh-2rem)] flex flex-col"
          onClick={(event) => event.stopPropagation()}
        >
          {/* Modal header */}
          <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t">
            <h3 className="text-2xl tracking-wide font-semibold text-gray-900">
              Agregar inmueble
            </h3>
            <div className="flex items-center space-x-2">
              <button
                type="button"
                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                onClick={toggleModal}
              >
                <svg
                  className="w-3 h-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 14"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  />
                </svg>
                <span className="sr-only">Close modal</span>
              </button>
            </div>
          </div>
          {/* Modal body */}
          <div className="flex justify-center p-4 md:p-5 overflow-y-auto custom-scrollbar min-h-0">
            <RealEstatesForm
              isEdit={false}
              toggleModal={toggleModal}
              handleOnSubmit={handleCreate}
              realEstateTypes={realEstateTypes}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
